export function isTsByPegType(pegType: string) {
  return ['TrailingStopPeg', 'TrailingTakeProfitPeg', 'TrailingStopByProportionPeg', 'TrailingTakeProfitByProportionPeg'].includes(pegType);
}

function isCloseOrder(order) {
  return order.execInst === 'CloseOnTrigger' && ['New', 'PartiallyFilled'].indexOf(order.ordStatus) > -1;
}

export function isTakeProfitOrder(order) {
  return order.ordStatus === 'Untriggered' && ['LimitIfTouched', 'MarketIfTouched'].includes(order.ordType);
}

export function isStopLossOrder(order) {
  return order.ordStatus === 'Untriggered' && ['Stop', 'StopLimit'].includes(order.ordType) && !isTsByPegType(order.pegPriceType);
}

export function isTrailingStopOrder(order) {
  return ['Stop'].indexOf(order.ordType) > -1 && isTsByPegType(order.pegPriceType) && ['Inactive', 'Untriggered'].includes(order.ordStatus);
}

function filterTpslByMode(order, mode: TpslCloseMode | 'All') {
  if (mode === 'Entire') {
    return order.orderQty === 0;
  }
  if (mode === 'Partial') {
    return order.orderQty !== 0;
  }
  return true;
}

function filterTsByMode(order, mode: TpslCloseMode | 'All') {
  if (mode === 'Entire') {
    return order.orderQty === 0;
  }
  if (mode === 'Partial') {
    return order.orderQty !== 0;
  }
  return true;
}

function filterOrderBindPos(order, position): Boolean {
  const {type} = position;
  if (type === 'Perpetual') {
    return order.symbol === position.symbol && order.curPosTerm === position.term;
  }
  if (type === 'PerpetualV2') {
    return order.symbol === position.symbol && order.curPosTerm === position.term && order.posSide === position.posSide;
  }
  return true;
}

function newFilterOrderBindPos(order: ContractConditionalOrder, position: Position): Boolean {
  const bindCond = order.curPosTerm === position.term && order.actionBy === 'FromPosition';
  const symbolCond = order.symbol === position.symbol;
  if (position.type === 'Perpetual') {
    return symbolCond && bindCond;
  }
  if (position.type === 'PerpetualV2') {
    const sideCond = order.posSide === position.posSide;
    return symbolCond && bindCond && sideCond;
  }
}

export function findCloseOrder(activeOrders, position): ContractActiveOrder[] {
  return activeOrders.filter((order) => filterOrderBindPos(order, position) && isCloseOrder(order));
}

function timeSortDesc(a: ContractConditionalOrder, b: ContractConditionalOrder) {
  return b.actionTimestamp - a.actionTimestamp;
}

export function findTakeProfitOrders(conditionalOrders: ContractConditionalOrder[], position: Position, mode: TpslCloseMode | 'All' = 'All'): ContractConditionalOrder[] {
  return conditionalOrders.filter((order) => newFilterOrderBindPos(order, position) && isTakeProfitOrder(order) && filterTpslByMode(order, mode)).sort(timeSortDesc);
}

export function findStopLossOrders(conditionalOrders: ContractConditionalOrder[], position: Position, mode: TpslCloseMode | 'All' = 'All'): ContractConditionalOrder[] {
  return conditionalOrders.filter((order) => newFilterOrderBindPos(order, position) && isStopLossOrder(order) && filterTpslByMode(order, mode)).sort(timeSortDesc);
}

export function findTrailingStopOrders(conditionalOrders: ContractConditionalOrder[], position: Position, mode: TpslCloseMode | 'All' = 'All'): ContractConditionalOrder[] {
  return conditionalOrders.filter((order) => newFilterOrderBindPos(order, position) && isTrailingStopOrder(order) && filterTsByMode(order, mode)).sort(timeSortDesc);
}
